import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'full' | 'icon' | 'text';
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'full', 
  size = 'medium',
  showText = false 
}) => {
  const theme = useTheme();
  
  const sizes = {
    small: {
      height: 30,
      width: 90,
      textVariant: 'body1' as const
    },
    medium: {
      height: 40,
      width: 120,
      textVariant: 'h6' as const
    },
    large: {
      height: 60,
      width: 480,
      textVariant: 'h5' as const
    }
  };

  const currentSize = sizes[size];

  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit'
      }}
    >
      {/* Logo imagen */}
      {(variant === 'full' || variant === 'icon') && (
        <Box
          component="img"
          src={theme.logo?.src || '/images/logo.jpg'}
          alt="Logo Escuela"
          sx={{
            height: currentSize.height,
            width: variant === 'icon' ? currentSize.height : 'auto',
            mr: showText ? 1 : 0,
            objectFit: 'contain'
          }}
        />
      )}

      
    </Box>
  );
};

export default Logo;